export const PrivacyPolicyPage = () => {
  return (
    <div className="fixed inset-0 bg-gradient-to-b from-indigo-950 via-purple-950 to-indigo-950 text-white p-6 overflow-y-auto">
      <div className="max-w-3xl mx-auto py-8">
        <h1 className="text-4xl font-bold mb-8 text-center">Privacy Policy</h1>
        <p className="text-gray-300 mb-8 text-center hidden">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </p>

        <div className="space-y-8 text-gray-200">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              1. Introduction
            </h2>
            <p className="leading-relaxed">
              Welcome to Sanctum of Sorcery ("we," "our," or "us"). We are
              committed to protecting your privacy and personal information.
              This Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you use our Tower Defense game on
              the SEI Network.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              2. Information We Collect
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-medium mb-2">
                  2.1 Wallet Information
                </h3>
                <p className="leading-relaxed">
                  When you connect your wallet, we collect your public wallet
                  address. We do not have access to your private keys or seed
                  phrases.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-medium mb-2">2.2 Game Data</h3>
                <p className="leading-relaxed">
                  We collect gameplay data including your game progress, scores,
                  achievements, in-game purchases, and PvP ranking information.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-medium mb-2">2.3 Technical Data</h3>
                <p className="leading-relaxed">
                  We automatically collect certain technical information such as
                  device type, browser type, IP address, and usage patterns to
                  improve our services.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              3. How We Use Your Information
            </h2>
            <ul className="list-disc list-inside space-y-2 leading-relaxed">
              <li>To provide and maintain our game services</li>
              <li>To process in-game transactions and purchases</li>
              <li>To manage your account and game progress</li>
              <li>To facilitate PvP matchmaking and leaderboards</li>
              <li>To communicate with you about updates and promotions</li>
              <li>To detect and prevent fraud or abuse</li>
              <li>To improve our game and user experience</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              4. Blockchain Transactions
            </h2>
            <p className="leading-relaxed">
              Please note that transactions on the SEI Network blockchain are
              public and immutable. While we protect your personal information,
              blockchain transaction data including wallet addresses and
              transaction details are publicly visible on the blockchain.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              5. Third-Party Services
            </h2>
            <p className="leading-relaxed">
              We use third-party services including Dynamic Labs for wallet
              connections and MoonPay for payment processing. These services
              have their own privacy policies, and we encourage you to review
              them. We are not responsible for the privacy practices of
              third-party services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              6. Data Security
            </h2>
            <p className="leading-relaxed">
              We implement appropriate technical and organizational security
              measures to protect your information. However, no method of
              transmission over the Internet or electronic storage is 100%
              secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              7. Data Retention
            </h2>
            <p className="leading-relaxed">
              We retain your personal information for as long as your account is
              active or as needed to provide you services. We may retain certain
              information as required by law or for legitimate business
              purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              8. Your Rights
            </h2>
            <p className="leading-relaxed mb-4">
              Depending on your location, you may have the following rights:
            </p>
            <ul className="list-disc list-inside space-y-2 leading-relaxed">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              9. Children's Privacy
            </h2>
            <p className="leading-relaxed">
              Our game is not intended for children under 13 years of age. We do
              not knowingly collect personal information from children under 13.
              If we learn we have collected such information, we will delete it
              promptly.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              10. Changes to This Policy
            </h2>
            <p className="leading-relaxed">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on
              this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-orange-400">
              11. Contact Us
            </h2>
            <p className="leading-relaxed">
              If you have any questions about this Privacy Policy, please
              contact us at:{' '}
              <a
                href="mailto:admin@mochi-studio.net"
                className="text-orange-400 hover:underline"
              >
                admin@mochi-studio.net
              </a>
            </p>
          </section>
        </div>

        <div className="mt-12 text-center">
          <a
            href="/"
            className="inline-block px-6 py-3 bg-gradient-to-r from-orange-500 to-yellow-500 text-white font-semibold rounded-xl border-2 border-black hover:scale-105 transition-transform"
          >
            Back to Game
          </a>
        </div>
      </div>
    </div>
  );
};
